import * as yup from 'yup'

export class CompanyClusterProgrammerCompanyDto {
  clusterProgrammerCompanyCode?: string = undefined
}

export const companyClusterProgrammerCompanyValidationSchema = yup.object<CompanyClusterProgrammerCompanyDto>({
  clusterProgrammerCompanyCode: yup
    .string()
    .min(3, 'Cluster Programmer Company Code must be 3 characters.')
    .max(3, 'Cluster Programmer Company Code must be 3 characters.')
    .required('Cluster Programmer Company Code is required.')
})
